import React, {useEffect, useState, useRef, useContext, useCallback} from 'react';
import useToken from "../Hooks/useToken";
import {useCartContext} from "../../Context/CartContext";
import { useNavigate } from 'react-router-dom';
import 'primeicons/primeicons.css';
import { Menubar } from 'primereact/menubar';
import {Image} from "react-bootstrap";
import IG_Logo from '../../common/image/IG logo.jpg'
import _ from "lodash";
import {Toast} from "primereact/toast";
import { Badge } from 'primereact/badge';

import "./Navbar.css"
import {authAPI} from '../../api/api'
import {clearCartRequiredField} from "../../common/Helpers/storageHelper";
import {useWindowDimensions} from "../../Context/WindowDimensionsContext";
import {NotificationContext} from "../../Context/NotificationContext"

const NavbarContainer = () => {

    const {token, setToken, deleteToken} = useToken();
    const { cart, getCart } = useCartContext();
    const [cartProductCount, setCartProductCount] = useState(0);
    const [accountCredentialsModel, setAccountCrederntialsModel] = useState(null);

    const navigate = useNavigate()
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();
    const { notifications, unreadCount } = useContext(NotificationContext);
    const toast = useRef(null);

    const [activeIndex, setActiveIndex] = useState(1);
    const [oldActiveIndex, setOldActiveIndex] = useState();

    const profileRender = useCallback((item) => {
        return (
            <a 
                className="flex align-items-center p-menuitem-link" 
            >
                <span className={item.icon} />
                <span className="mx-2" style={{ whiteSpace: 'nowrap' }}>{item.label}</span>
                {item.isNewNotification && <i className="pi pi-envelope p-overlay-badge">
                    <Badge severity="danger"></Badge>
                </i>}
                {item.badge && item.badge > 0 ? <Badge className="ml-auto" severity="info" value={item.badge} /> : null}
            </a>
        );
    }, [navigate]);

    const initItems = [
        {
            id: 0,
            label: 'Профіль',
            icon: "pi pi-home",
            isNewNotification: unreadCount > 0,
            template: profileRender,
            items: [
                {
                    id: 11,
                    label: 'Моя сторінка',
                    icon: "pi pi-home",
                    path: '/profile',
                    template: profileRender,
                    command: (e) => {
                        onLinkClick(e.item)
                    }
                },
                {
                    id: 12,
                    label: 'Мої повідомлення',
                    icon: "pi pi-envelope",
                    badge: unreadCount,
                    path: '/notifications',
                    template: profileRender,
                    command: (e) => {
                        onLinkClick(e.item)
                    }
                }
            ],
        },
        {
            id: 1,
            label: 'Каталог товарів',
            icon: "pi pi-list",
            path: '/catalog',
            command: (e) => {
                onLinkClick(e.item)
            }
        },
        {
            id: 2,
            label: 'Акції',
            icon: "pi pi-megaphone",
            path: '/marketingStockWrapper',
            command: (e) => {
                onLinkClick(e.item)
            }
        },
        {
            id:10,
            label: 'Shell підбір оливи',
            icon: "pi pi-database",
            path: '/lubematch',
            command: (e) => {
                onLinkClick(e.item)
            }
        },
        {
            id: 4,
            label: 'Історія замовлень',
            icon: "pi pi-history",
            path: '/history',
            command: (e) => {
                onLinkClick(e.item)
            }
        },
        {
            id: 5,
            label: cartProductCount >0 ? "+" +cartProductCount+ ' Кошик': 'Кошик',
            badge: cartProductCount,
            icon: "pi pi-shopping-cart",
            path: '/cart',
            command: (e) => {
                onLinkClick(e.item)
            }
        },
        {
            id: 6,
            label: 'Вийти',
            icon: "pi pi-power-off",
            path: '/login',
            command: (e) => {
                onLinkClick(e.item)
            }
        }

    ]

    const [menubarItems, setMenubarItems] = useState(initItems)

    const setActualMenubarItems = () => {
        const actualMenubarItems = _.cloneDeep(initItems);
        if(accountCredentialsModel === null){return;}

        const otherAccountCredItems = accountCredentialsModel.other.map(ac => {
            return {
                label: ac.AccountName,
                icon: 'pi pi-user',
                id: ac.AccountCredentialsId,
                command: (e) => {
                    changeAccountCred(e.item)
                }
            }
        } );

        otherAccountCredItems.push({
            id: 6,
            label: 'Вийти',
            icon: "pi pi-power-off",
            path: '/login',
            command: (e) => {
                onLinkClick(e.item)
            }
        })

        const currentAccountName = accountCredentialsModel.current.AccountName;
        otherAccountCredItems.unshift({id: accountCredentialsModel.current.AccountCredentialsId, label: currentAccountName, icon: 'pi pi-angle-right'})
        
        let truncatedCurrentAccountName = currentAccountName;
        let numberOfChar = 0;

        if(viewPortWidth > 1500 ){
            numberOfChar = 40;
            if(currentAccountName.length > numberOfChar + 3 )
            {
                truncatedCurrentAccountName = accountCredentialsModel.current.AccountName.slice(0, numberOfChar) + '...'
            }
        }
        else if(viewPortWidth <= 1500 && viewPortWidth > 1300){
            numberOfChar = 30;
            if(currentAccountName.length > numberOfChar + 3 )
            {
                truncatedCurrentAccountName = accountCredentialsModel.current.AccountName.slice(0, numberOfChar) + '...'
            }
        }

        else if(viewPortWidth <= 1300 && viewPortWidth > 1200){
            numberOfChar = 20;
            if(currentAccountName.length > numberOfChar + 3 )
            {
                truncatedCurrentAccountName = accountCredentialsModel.current.AccountName.slice(0, numberOfChar) + '...'
            }
        }
        else if(viewPortWidth <= 1200 && viewPortWidth > 1100){
            numberOfChar = 13;
            if(currentAccountName.length > numberOfChar + 3 )
            {
                truncatedCurrentAccountName = accountCredentialsModel.current.AccountName.slice(0, numberOfChar) + '...'
            }
        }


        actualMenubarItems[actualMenubarItems.length -1] = {
            className: 'cred-list', // Добавляем кастомный класс
            label: truncatedCurrentAccountName,
            icon: 'pi pi-users',
            items: otherAccountCredItems
        }

        console.log('actualMenubarItems:', actualMenubarItems)

        setMenubarItems(actualMenubarItems)
    }

    const onLinkClick = (item) => {
        if(!item.path){
            return;
        }

        if(item.id === 6){
            deleteToken();
            clearCartRequiredField();
        }

        navigate(item.path)
    }

    useEffect(() => {
        fetchAvailableAccountCredData().then();
    }, [token])

    useEffect(() => {
        setActualMenubarItems();
    }, [cartProductCount, accountCredentialsModel, notifications ])

    useEffect(() => {
        let url = window.location.pathname;
        try{
            const element = menubarItems.find(obj => {
                return obj.path === url;
            })
            setActiveIndex(element.id);
            setOldActiveIndex(element.id)
        }
        catch (ex){
            console.log(ex.message)
            setActiveIndex(menubarItems[0].id);
        }
    },[])

    useEffect(() => {
        if(cart){
            (async () => {
                const cart1 = await getCart();

                let productCount = 0;

                if(!cart1){
                    setCartProductCount(productCount)
                }
                else{
                    const cartObj = JSON.parse(cart1)
                    const baseProdCount = cartObj.BaseOrder.length;
                    let stockProdLength = 0;
                    
                    cartObj.Stocks.forEach(stock => {
                        stockProdLength += stock.ProductList.length
                        
                        if(stock.ProductSetList){
                            stock.ProductSetList.forEach(setItem => {
                                stockProdLength += setItem.productList?.length
                            })
                        }
                    });
                    productCount = baseProdCount + stockProdLength;
                    setCartProductCount(productCount)
                }
            })();
        }
    }, [cart])

    const fetchAvailableAccountCredData = async () => {
        const {data} = await authAPI.getAvailableAccountCredentials();
        let resp = JSON.parse(data);
        if(resp.isSucccess){
            console.log('fetchAvailableAccountCredData', resp)
            setAccountCrederntialsModel(resp.data)
        }
        else{
            
        }
    }

    const changeAccountCred = async (model) => {
        debugger
        if(model){
            
            const {data} = await authAPI.changeAccountCredentials(model.id);
            let resp = JSON.parse(data);
            if(resp.isSucccess){
                setToken(resp.data.token, true);
                window.location.reload(true);
            }
            else{
                toast.current.clear();
                toast.current.show({severity: 'error', summary: 'Помилка', clearPrevious: true, detail: resp.message, life: 2000});
            }
        }
    }

    const getFirstPathSegment = (path) => {
        const parts = path.split("/");
        return '/' + parts[1];
    }


    const start =() => {
        if(viewPortWidth <= 1100) {
            return (
                <Image src={IG_Logo} style={{width: '25px'}}/>
            )
        }
    }

    const end = () => {
        if(viewPortWidth <= 1100) {
            const path = getFirstPathSegment(window.location.pathname);
            const item = menubarItems.find(obj => {
                if(path === '/stock'){
                    return obj.path === '/marketingStockWrapper'
                }

                return obj.path === path;
            })

            if(!item){return  null}

            let currentElement = <div></div>;
            if(item.path !== '/cart') {
                currentElement = (
                    <div>

                        <span>{item.label}</span>
                    </div>
                )
            }
            else{
                currentElement = <span>Кошик</span>
            }


            return (
                    <div style={{display:'flex', justifyContent:"space-between"}}>
                        {currentElement}
                        {cartProductCount > 0 ?
                            <div style={{fontSize:'1.1rem', color:"#6c757d", paddingRight:'10px'}} onClick={() =>  onLinkClick({id:5, path:'/cart'})}>
                                <i style={{fontSize:'1.3rem'}} className='pi pi-shopping-cart'> </i>
                                <span>+{cartProductCount}</span>

                            </div>
                        : <span></span>}
                    </div>
            )
        }
        return null;

    }

    return(

        <>
            <Toast ref={toast}></Toast>
            {token !== null ?
                <Menubar  className={`navbar navbar-custom`} model={menubarItems}  start={start} end={end} />
            : null}
        </>

    )
}

export default NavbarContainer;